import {
    CardMedia,
    Button,
    CardActions,
    CardHeader,
    CardContent,
    useMediaQuery
} from '@mui/material'
import {
    CoreTypography,
    LeafFixedMediaCard,
    useTheme
} from '@thriveglobal/thrive-web-leafkit'
import { PLACEHOLDER_FEATURED_CARD_IMAGE } from '../../../utils'

type HeaderProps = {
    title: React.ReactNode
    subTitle: React.ReactNode
}

type ButtonProps = {
    title: string
    onClick: () => void
}

export default function FeaturedCard({
    headerProps,
    title,
    subTitle,
    description,
    imageUrl,
    imageAlt,
    buttonProps,
    secondaryActions
}: {
    headerProps?: HeaderProps
    title?: string
    subTitle?: string
    imageUrl?: string
    imageAlt?: string
    description?: string
    buttonProps?: ButtonProps
    secondaryActions?: React.ReactNode
}) {
    const theme = useTheme()
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'))
    const image = imageUrl || PLACEHOLDER_FEATURED_CARD_IMAGE

    return (
        <LeafFixedMediaCard
            alignMedia={isSmallScreen ? 'top' : 'left'}
            media={
                <CardMedia
                    image={image}
                    aria-label={imageAlt || title || 'Featured content'}
                />
            }
            mediaWidth="lg"
        >
            {headerProps && (
                <CardHeader
                    title={headerProps.title}
                    subheader={headerProps.subTitle}
                />
            )}
            <CardContent>
                <CoreTypography variant="h3">{title}</CoreTypography>
                <CoreTypography variant="body2">{subTitle}</CoreTypography>
            </CardContent>

            <CardContent>
                <CoreTypography variant="body1">{description}</CoreTypography>
            </CardContent>
            <CardActions>
                {buttonProps && (
                    <Button
                        role="button"
                        color="primary"
                        variant="contained"
                        size="large"
                        aria-label={buttonProps.title}
                        onClick={buttonProps.onClick}
                    >
                        <CoreTypography customVariant="buttonLarge">
                            {buttonProps.title}
                        </CoreTypography>
                    </Button>
                )}
                {secondaryActions}
            </CardActions>
        </LeafFixedMediaCard>
    )
}
